/** Extended amount for a PO line (qty × unit price), 2 decimal places. */
export function computePOLineExtended(item) {
  const q = Number(item.quantity_ordered) || 0;
  const p = parseFloat(item.unit_price);
  const unit = Number.isFinite(p) ? p : 0;
  return Math.round(q * unit * 100) / 100;
}

export function computePOLinesSubtotal(items) {
  if (!Array.isArray(items)) return 0;
  return Math.round(items.reduce((sum, it) => sum + computePOLineExtended(it), 0) * 100) / 100;
}
